import * as Yup from 'yup';
import { t } from 'i18next';
import { countryToMobilePhoneDigitsMapping } from '../../resources/base/models';

export const regExEmail =
  /^[a-z0-9_!&'*+/=]+(?:[.\-\u2013][a-z0-9_!&'*+/=]+)*@[a-z0-9]+(?:[.\-\u2013][a-z0-9]+)*\.[a-z]{2,}$/i;
export const regexVin = /^[A-HJ-NPR-Z0-9]*$/;

export const validateEmail = () =>
  Yup.string()
    .matches(regExEmail, () => t('validation:invalidEmail'))
    .required(() => t('validation:required'));

export const validateVIN = () =>
  Yup.string()
    .min(17, () => t('validation:minLength', { value: 17 }))
    .max(17, () => t('validation:maxLength', { value: 17 }))
    .matches(regexVin, () => t('dashboard:popup:invalidVinNumberTitle'))
    .required(() => t('validation:required'));

export const validateMobilePhone = (required = true) =>
  Yup.string().when('mobilePhoneCountryCode', ([countryCode], schema) => {
    const digits =
      countryToMobilePhoneDigitsMapping[countryCode as unknown as keyof typeof countryToMobilePhoneDigitsMapping]
        ?.digits || [];

    if (!digits.length) return schema;

    const minLength = Math.min(...digits);
    const maxLength = Math.max(...digits);
    const maxLengthFrenchMobile = 9;

    const isFrenchMobile = (countryCode as unknown as keyof typeof countryToMobilePhoneDigitsMapping) === '+33';

    const validationSchema = schema.when([], {
      is: () => required === true,
      then: (schema) => schema.required(() => t('validation:required')),
    });

    if (isFrenchMobile) {
      return validationSchema
        .test('french-leading-zero', t('validation:noZeroInMobilePhone'), (value) => !value || !/^0/.test(value))
        .matches(/^[67]\d+$/, () => t('validation:invalidMobilePhone'))
        .min(minLength, () => t('validation:minLength', { value: minLength }))
        .max(maxLengthFrenchMobile, () => t('validation:maxLength', { value: maxLengthFrenchMobile }));
    }

    return validationSchema
      .min(minLength, () => t('validation:minLength', { value: minLength }))
      .max(maxLength, () => t('validation:maxLength', { value: maxLength }));
  });
